import React from 'react';
import { Stack, Box } from '@mui/material';
import { BannerDescription } from 'new/elements/BannerDescription';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_AI_TOOLS } from 'new/constants/pathnames';
import { ToolsTab } from './ToolsTab';
import styles from './ToolsManagementSection.module.scss';

export const ToolsManagementSection: ScreenComponent<Record<string, never>> = () => {
  return (
    <Stack className={styles.container}>
      <BannerDescription
        title="Tools"
        description="Create and manage individual AI tools from your Nexsets. Tools can be added to toolsets for MCP deployment."
      />

      <Box className={styles.tabContent}>
        <ToolsTab />
      </Box>
    </Stack>
  );
};

ToolsManagementSection.displayName = 'ToolsManagementSection';

ToolsManagementSection.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_AI_TOOLS}`,
  domain: 'ai',
  header: {
    title: 'Tools',
    slugTitle: 'Tools',
  },
  screenName: 'ToolsManagement',
};
